import { Injectable } from '@angular/core';
// import { NgxConfigureService } from 'ngx-configure';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private defaultLanguage = '';
  private logo = '';
  private skin = '';
  public config: any = {}

  constructor() {
    // this.config = configService.config;
  }

  private getPropertyFromConfigOrDefaultValue(prop: string, defaultValue: any): typeof defaultValue {
    const value = this.config[prop];
    if (!value) {
      return defaultValue;
    }
    return value;
  }

  getSpotDecimalPrecisionForCurrencyPair(cp: string): number {
    const spotFormatsToCps = this.getPropertyFromConfigOrDefaultValue('SpotDecimalPrecision', null);
    if (!spotFormatsToCps || typeof spotFormatsToCps[cp] === typeof undefined) {
      return this.getPropertyFromConfigOrDefaultValue('DefaultSpotDecimalPrecision', 2);
    }
    return spotFormatsToCps[cp];
  }

  getSocketUrl() {
    return this.config.SocketUrl;
  }

  getProtocolVersion(): string {
    return this.getPropertyFromConfigOrDefaultValue('ProtocolVersion', '100');
  }

  getIsRegisterEnabled(): boolean {
    return this.getPropertyFromConfigOrDefaultValue('RegisterEnabled', false);
  }


////////////////////////////////// LOCAL LANGUAGE ///////////////////////////
  getLocale() {
    this.defaultLanguage = this.config.Locale;
    return this.defaultLanguage;
  }

  getLogo() {
    this.logo = this.config.Logo;
    return this.logo;
  }

  getSkin() {
    this.skin = this.config.Skin;
    return this.skin;
  }
}
